import { z } from 'zod';
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export function paginatedResponseSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        total: z.number().int().min(0),
        page: z.number().int().min(1),
        pageSize: z.number().int().min(1),
        hasMore: z.boolean(),
    });
}
//# sourceMappingURL=pagination.js.map